var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svgicon',{class:{
    [_vm.$options.name]: true,
    [`${_vm.$options.name}--${_vm.size}`]: _vm.size
  },attrs:{"original":_vm.original,"color":_vm.color,"name":_vm.name}})
}
var staticRenderFns = []

export { render, staticRenderFns }